export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.d8e8e0f7.woff";